module.exports = __webpack_public_path__ + "img/okina matara_sc2.25319856.png";